import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CardContainer from '../components/CardContainer'
import { Container, Row, Col } from 'react-bootstrap'
import { Loading } from '../components/Loading'
import ErrorPage from './ErrorPage';
import { getSearchResult } from '../store/action/index'

function SearchResult(props) {
    const dispatch = useDispatch()
    const movies = useSelector(state => state.moviesSearch)
    const loading = useSelector(state => state.loading)
    const error = useSelector(state => state.error)
    const query = useSelector(state => state.query)

    useEffect(() => {
        dispatch(getSearchResult(query))
    }, [])

    console.log(movies, 'data di search page')

    if(loading) return <Loading/>
    if(error) return <ErrorPage/>

    return (
        <>
            <Container>
                <Row>
                    <Col xs={6} md={12}>
                        <CardContainer movies={ movies.data } title={ 'Search Results' }/>
                    </Col>
                </Row>
            </Container>
        </>
    )

}

export default SearchResult